module.exports = __webpack_public_path__ + "static/media/parCurve.b66b3897.png";